module.exports = __webpack_public_path__ + "static/media/Empty_Info@3x.dbce53e8.png";